import {
  SET_PERSONALIZED_STOPS,
  PersonalizedStopActionTypes,
} from "./personalizedStops.Actions";

const initialState = { personalizedStops: null };

const PersonalizedStopsReducer = (
  state = initialState,
  action: PersonalizedStopActionTypes
) => {
  switch (action.type) {
    case SET_PERSONALIZED_STOPS:
      return {
        personalizedStops: action && action.payload ? [...action?.payload] : [],
      };
    default:
      return state;
  }
};

export default PersonalizedStopsReducer;
